var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18H2.5C0.9575 18 0 17.0425 0 15.5V1C0 0.4475 0.4475 0 1 0C1.5525 0 2 0.4475 2 1V15.5C2 15.95 2.05 16 2.5 16H19C19.5525 16 20 16.4475 20 17C20 17.5525 19.5525 18 19 18ZM12 13V9C12 8.4475 11.5525 8 11 8C10.4475 8 10 8.4475 10 9V13C10 13.5525 10.4475 14 11 14C11.5525 14 12 13.5525 12 13ZM16 14C15.4475 14 15 13.5525 15 13V7C15 6.4475 15.4475 6 16 6C16.5525 6 17 6.4475 17 7V13C17 13.5525 16.5525 14 16 14ZM6 14C5.4475 14 5 13.5525 5 13V11C5 10.4475 5.4475 10 6 10C6.5525 10 7 10.4475 7 11V13C7 13.5525 6.5525 14 6 14ZM16.9225 0.6175C16.7675 0.245 16.4025 0 16 0H13C12.4475 0 12 0.4475 12 1C12 1.5525 12.4475 2 13 2H13.585L11.6675 3.9175C11.5675 4.0125 11.4075 4.0125 11.3075 3.9175L10.1575 2.7675C9.2775 1.8875 7.85 1.8875 6.9675 2.7675L5.2925 4.4425C4.8975 4.8275 4.89 5.4625 5.2775 5.8575C5.6625 6.2525 6.2975 6.26 6.6925 5.8725C6.6975 5.8675 6.7025 5.8625 6.7075 5.8575L8.3825 4.1825C8.4825 4.085 8.6425 4.085 8.745 4.1825L9.895 5.3325C10.7775 6.2125 12.2025 6.2125 13.085 5.3325L15.0025 3.415V4C15.0025 4.5525 15.45 5 16.0025 5C16.555 5 17.0025 4.5525 17.0025 4V1C17.0025 0.87 16.975 0.74 16.925 0.6175H16.9225Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.9e0f82a578234fee7b5a38de45c136f5.svg";
export { ForwardRef as ReactComponent };